import { LocaleProvider } from '@chakra-ui/react';
import { createLDReactProviderWithClient } from '@launchdarkly/react-sdk';
import { QueryClientProvider } from '@tanstack/react-query';
import React from 'react';
import { RouterProvider } from 'react-router/dom';
import { AppChakraProvider } from './components/AppChakraProvider';
import { ldClient } from './lib/launchDarkly';
import { queryClient } from './lib/trpc';
import { router } from './router';
import { system } from './theme';

// Module scope (not the entry: main.tsx must stay free of component
// bindings — see its header comment) and outside StrictMode, as before.
const LDProvider = createLDReactProviderWithClient(ldClient);

export default function App() {
    return (
        <LDProvider>
            <React.StrictMode>
                <AppChakraProvider system={system}>
                    {/* Ark components default to en-US without this; number
                    inputs parse/format amounts in the browser's locale. */}
                    <LocaleProvider locale={navigator.language}>
                        {/* The shell's query client; the remote mounts its own
                        inside FederatedApp. */}
                        <QueryClientProvider client={queryClient}>
                            <RouterProvider router={router} />
                        </QueryClientProvider>
                    </LocaleProvider>
                </AppChakraProvider>
            </React.StrictMode>
        </LDProvider>
    );
}
